import { render, staticRenderFns } from "./unit-introduction.vue?vue&type=template&id=8785022c&scoped=true"
import script from "./unit-introduction.vue?vue&type=script&lang=js"
export * from "./unit-introduction.vue?vue&type=script&lang=js"
import style0 from "./unit-introduction.vue?vue&type=style&index=0&id=8785022c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8785022c",
  null
  
)

export default component.exports